import { REGION_MAP } from '../../constants/region';

/**
 * Every region the product knows, flattened out of `REGION_MAP` in provider order. The Region filter
 * control (`./RegionFilter.tsx`) wants a list; everything else wants to look a code up by name, so
 * the map is the one place a region is written down and this is a view of it.
 *
 * It used to be its own literal, which is how the two drifted: `ca-west-1` sat in this list and not
 * in the map, so the filter offered Calgary while anything naming a region from the map showed a
 * Calgary asset its raw code. Deriving the list cannot drift, which is better than a test telling us
 * it has.
 */
export const REGION_LIST = Object.values(REGION_MAP).flatMap((provider) =>
  Object.values(provider),
);
